import type {
  BasicTableValues,
  ChartFormValues,
  TileValues
} from '@/features/Dashboard/form/AppForm/context/types';
import { AppType } from '@/features/Dashboard/types';
import AppFormAdapter from '@/features/Dashboard/utils/AppFormAdapter';

export function getAppTemplateFromFormValues(
  values: ChartFormValues | BasicTableValues | TileValues
) {
  switch (values.type) {
    case AppType.Table:
      return AppFormAdapter.newApp({
        values: {
          name: values.name,
          symbols: values.symbols,
          type: AppType.Table
        }
      });
    case AppType.Tiles:
      return AppFormAdapter.newApp({
        values: { symbols: values.symbols, type: AppType.Tiles }
      });
    default:
      return AppFormAdapter.newApp({
        values: {
          from: values.from,
          name: values.name,
          type: values.type,
          symbols: values.symbols,
          colorPalette: values.colorPalette
        } as ChartFormValues
      });
  }
}
